<template>
  <div class="c-general-tab">
    <CsvSection v-if="isCSVFeed" />
    <OtherSection v-else />
  </div>
</template>

<script setup lang="ts">
import useDataSourceSettings from '@/composables/useDataSourceSettings';

import CsvSection from './CsvSection.vue';
import OtherSection from './OtherSection.vue';

const { isCSVFeed } = useDataSourceSettings();
</script>

<style lang="pcss">
.c-general-tab {
  .c-general-tab__section-with-description {
    @apply flex justify-between w-full flex-col items-start gap-16 md:flex-row md:items-center;
    .c-general-tab__section-with-description__text {
      @apply text-sm text-neutral-text flex flex-col;
    }
  }

  .c-general-tab__section {
    @apply flex justify-between items-center py-20;

    &:first-of-type {
      @apply pt-0;
    }

    h3 {
      @apply font-bold text-neutral-text-strong text-base normal-case tracking-normal;
    }

    &:not(:last-of-type) {
      @apply border-b border-neutral-border;
    }
  }
}
</style>
